export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/redux-form@6.8.0_btckld2a72haxcqt7vtk4t56yu/~/redux-form/es/util/eventConsts.js
// module id = 680
// module chunks = 0